(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__drawerIntentCapture) return;
    window.__drawerIntentCapture = true;
    window.__pendingDrawerOpens = window.__pendingDrawerOpens || {};
    document.addEventListener('click', function (event) {
      var opener = event.target && event.target.closest ? event.target.closest('slide-out-drawer-opener') : null;
      if (!opener || opener.isInitialized) return;
      var drawerId = opener.getAttribute('data-drawer');
      if (drawerId) window.__pendingDrawerOpens[drawerId] = Date.now();
    }, { capture: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
